import { render, staticRenderFns } from "./NominaGuardada.vue?vue&type=template&id=849220b0&"
import script from "./NominaGuardada.vue?vue&type=script&lang=js&"
export * from "./NominaGuardada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports